import { Button, ChoiceList, Popover } from "@shopify/polaris";
import { SortAscendingMajor, SortDescendingMajor } from "@shopify/polaris-icons";
import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { SortOrder } from "src/graphql/codegen_graphql";

interface Props {
  orderBy: SortOrder;
  setOrderBy: (value: SortOrder) => void;
}

export function FilterOrder(props: Props) {
  const { t } = useTranslation();
  const [active, setActive] = useState(false);

  const toggleActive = useCallback(() => setActive(!active), [active]);
  return (
    <Popover
      activator={
        <Button
          size="slim"
          onClick={toggleActive}
          icon={props.orderBy === SortOrder.Asc ? SortAscendingMajor : SortDescendingMajor}
        ></Button>
      }
      active={active}
      onClose={toggleActive}
    >
      <Popover.Section>
        <ChoiceList
          title
          titleHidden
          choices={[
            { label: t("ascending"), value: SortOrder.Asc },
            { label: t("descending"), value: SortOrder.Desc },
          ]}
          selected={[props.orderBy]}
          onChange={(v) => props.setOrderBy(v[0] as SortOrder)}
        />
      </Popover.Section>
    </Popover>
  );
}
